import { render, staticRenderFns } from "./CriarSecao.vue?vue&type=template&id=61c47cfe&scoped=true"
import script from "./CriarSecao.vue?vue&type=script&lang=js"
export * from "./CriarSecao.vue?vue&type=script&lang=js"
import style0 from "./CriarSecao.vue?vue&type=style&index=0&id=61c47cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c47cfe",
  null
  
)

export default component.exports